import api from '@utils/http'

/**
 * 获取首页信息
 * @param {}  
 */
export const apiHomeData = p=>api.post('course/home/getData',p)
/**
 * 获取名师列表
 * @param {}  
 */
export const apiTeacherList = p=>api.post('course/teacher/getList',p)
/**
 * 获取老师详情
 * @param {teacher_id}  
 */
export const apiTeacherDetail = p=>api.post('course/teacher/getDescById',p)
/**
 * 关注取消关注老师
 * @param {teacher_id,status}
 * status: 0,1  
 */
export const apiTeacherAttention = p=>api.post('course/teacher/teacherAttention',p)
/**
 * 获取留言列表
 * @param {}  
 */
export const apiMessageList = p=>api.post('course/leaveMessage/getList',p)
/**
 * 留言
 * @param {desciption}  
 */
export const apiMessageLeave = p=>api.post('my/submitleaveMessage',p)
/**
 * 获取资讯分类
 * @param {}  
 */
export const apiNewsClassify = p=>api.post('news/getNewsKindList',p)
/**
 * 根据资讯分类查询列表
 * @param {kind_id}  
 */
export const apiNewsList = p=>api.post('news/getNewsList',p)

/**
 * 查询资讯详情
 * @param {news_id}  
 */
export const apiNewsDetail = p=>api.post('news/getNewsDesc',p)

/**
 * 获取签到状态
 * @param {}  
 */
export const apiSignStatus = p => api.post('signIn/getSignInState', p)

/**
 * 获取签到状态
 * @param {}  
 */
export const apiSignIn = p => api.post('signIn/userSignInGetIntegral', p)
